import { createExposureSessionLatch } from './exposure-session-latch';

/** Latches minimal-cart experiment exposures per Amplitude session. */
export const minimalCartExposureSessionLatch = createExposureSessionLatch();
